const S3 = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/";

const CLASS_DISPLAY = {
  nursery: "Nursery",
  nur: "Nursery",
  lkg: "LKG",
  ukg: "UKG",
  class1: "Class 1",
  classi: "Class 1",
  class2: "Class 2",
  classii: "Class 2",
  class3: "Class 3",
  classiii: "Class 3",
  class4: "Class 4",
  classiv: "Class 4",
  class5: "Class 5",
  classv: "Class 5",
  class6: "Class 6",
  classvi: "Class 6",
  class7: "Class 7",
  classvii: "Class 7",
  class8: "Class 8",
  classviii: "Class 8",
  class9: "Class 9",
  classix: "Class 9",
  class10: "Class 10",
  classx: "Class 10",
  class11: "Class 11",
  classxi: "Class 11",
  class12: "Class 12",
  classxii: "Class 12",
};

export function normTitle(title) {
  return String(title || "").trim().toLowerCase();
}

export function tabFromTitle(title) {
  const t = normTitle(title);
  const compact = t.replace(/[\s_\-]+/g, "");

  if (compact.includes("assessment4") || t.includes("assessment 4")) return "Assessment 4";
  if (compact.includes("assessment3") || t.includes("assessment 3")) return "Assessment 3";
  if (compact.includes("assessment2") || t.includes("assessment 2")) return "Assessment 2";
  if (compact.includes("assessment1") || t.includes("assessment 1")) return "Assessment 1";
  if (compact.includes("pt3") || t.includes("pt-3") || t.includes("pt 3")) return "PT-3";
  if (compact.includes("pt2") || t.includes("pt-2") || t.includes("pt 2")) return "PT-2";
  if (compact.includes("pt1") || t.includes("pt-1") || t.includes("pt 1")) return "PT-1";
  if (t.includes("half yearly") || t.includes("half-yearly") || compact.includes("halfyearly")) {
    return "Half Yearly Examination";
  }
  if (t.includes("annual examination") || t.includes("annual")) return "Annual Examination";

  return null;
}

export function classLabelFromTitle(title, classRank) {
  const titleKey = normTitle(title).replace(/[^a-z0-9]/g, "");
  const keys = Object.keys(classRank).sort((a, b) => b.length - a.length);

  for (const key of keys) {
    if (titleKey.includes(key)) return CLASS_DISPLAY[key] || key;
  }

  return String(title || "").trim();
}

export function classRank(label, rankMap) {
  const key = String(label).toLowerCase().replace(/[^a-z0-9]/g, "");
  return rankMap[key] ?? 99;
}

export function sortByClass(items, rankMap) {
  return [...items].sort(
    (a, b) => classRank(a.classLabel, rankMap) - classRank(b.classLabel, rankMap),
  );
}

export function buildSyllabusByTab(items, category, tabs, classRankMap) {
  const byTab = Object.fromEntries(tabs.map((name) => [name, []]));

  (items || [])
    .filter((item) => item?.category === category)
    .forEach((item) => {
      const tab = tabFromTitle(item.title);
      if (!tab || !byTab[tab]) return;

      byTab[tab].push({
        classLabel: classLabelFromTitle(item.title, classRankMap),
        fileName: item?.attachments?.[0]
          ? S3 + item.attachments[0]
          : "",
      });
    });

  tabs.forEach((name) => {
    byTab[name] = sortByClass(byTab[name], classRankMap);
  });

  return byTab;
}

export function pdfHref(fileName) {
  if (!fileName) return "#";
  if (fileName.startsWith("http")) return fileName;
  return encodeURI(`/pdf/${fileName}`);
}
